import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from './firestore.service';
import type { TPricingInfo } from '@shared/models';

@Injectable({
    providedIn: 'root'
})
export class PricesService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getObservable(): Observable<TPricingInfo[]> {
        const path = this.firestorePathsService.getPricesPath();
        const observable = this.firestoreService.getObservable(path);
        return observable as Observable<TPricingInfo[]>;
    }

    public getByUid(uid: string): Promise<TPricingInfo> {
        const path = this.firestorePathsService.getPricesPath();
        return this.firestoreService.getByUid(path, uid) as Promise<TPricingInfo>;
    }

    public getAll(): Promise<TPricingInfo[]> {
        const path = this.firestorePathsService.getPricesPath();
        return this.firestoreService.getAll(path) as Promise<TPricingInfo[]>;
    }

    public add(user: TPricingInfo): Promise<TPricingInfo> {
        const path = this.firestorePathsService.getPricesPath();
        return this.firestoreService.add(path, user) as Promise<TPricingInfo>;
    }

    public update(price: TPricingInfo): Promise<TPricingInfo> {
        const path = this.firestorePathsService.getPricesPath();
        return this.firestoreService.update(path, price);
    }

    public set(price: TPricingInfo, uid = ''): Promise<TPricingInfo> {
        if (uid) {
            price.uid = uid;
        }
        const collection = this.firestorePathsService.getPricesPath();
        return this.firestoreService.set(collection, price) as Promise<TPricingInfo>;
    }

    public delete(uid: string): Promise<void> {
        const collection = this.firestorePathsService.getPricesPath();
        return this.firestoreService.delete(collection, uid) as Promise<void>;
    }
}
